/**
 * Sayfa animasyonları için yardımcı fonksiyonlar
 */

/**
 * Başlık içindeki metinlere rastgele fade-in animasyonu ekler
 */
export const initTitleAnimation = () => {
  // Başlık içindeki tüm metin ve görsel öğeleri için rastgele gecikme süreleri oluştur
  const elements = document.querySelectorAll('.window-load-slide-text > span, .window-load-slide-text > div');
  
  // Her öğeye rastgele bir gecikme süresi ekle
  elements.forEach((element, index) => {
    const delay = Math.random() * 2; // 0-2 saniye arasında rastgele bir değer
    element.style.animationDelay = `${delay}s`;
    element.classList.add('fade-in-element');
  });
  
  // CSS animasyonunu dinamik olarak ekle
  const style = document.createElement('style');
  style.innerHTML = `
    .fade-in-element {
      opacity: 0;
      animation: fadeIn 1s ease-in-out forwards;
    }
    
    @keyframes fadeIn {
      0% {
        opacity: 0;
        transform: translateY(20px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  document.head.appendChild(style);
  
  // Temizleme fonksiyonu
  return () => {
    document.head.removeChild(style);
  };
};

/**
 * Açıklama metni ve video oynatma butonuna fade-in animasyonu ekler
 */
export const initDescAnimation = () => {
  // Açıklama metni ve video oynatma butonunu seç
  const descElement = document.querySelector('.window-load-slide-desc');
  const videoPlayElement = document.querySelector('.window-load-slide-video-play');
  
  if (descElement) {
    // Açıklama metnine animasyon ekle
    descElement.classList.add('fade-in-element');
    descElement.style.animationDelay = '1.5s'; // Başlıktan sonra görünsün
  }
  
  if (videoPlayElement) {
    // Video oynatma butonuna animasyon ekle
    videoPlayElement.classList.add('fade-in-element');
    videoPlayElement.style.animationDelay = '2s'; // Açıklamadan sonra görünsün
  }
};

/**
 * Header menüsündeki öğelere fade-in animasyonu ekler
 */
export const initHeaderAnimation = () => {
  // Header menüsündeki tüm öğeleri seç
  const menuItems = document.querySelectorAll('.header-menu ul li');
  const logoElement = document.querySelector('.header-logo');
  const searchElement = document.querySelector('.header-search-inp');
  const languageElement = document.querySelector('.header-language');
  
  // Logo animasyonu
  if (logoElement) {
    logoElement.classList.add('fade-in-element');
    logoElement.style.animationDelay = '0.2s';
  }
  
  // Menü öğeleri animasyonu
  menuItems.forEach((item, index) => {
    item.classList.add('fade-in-element');
    item.style.animationDelay = `${0.3 + (index * 0.1)}s`; // Sırayla görünsün
  });
  
  // Arama butonu animasyonu
  if (searchElement) {
    searchElement.classList.add('fade-in-element');
    searchElement.style.animationDelay = '0.8s';
  }
  
  // Dil seçimi animasyonu
  if (languageElement) {
    languageElement.classList.add('fade-in-element');
    languageElement.style.animationDelay = '0.9s';
  }
};

/**
 * Video hover efektlerini ekler
 */
export const initVideoHoverEffects = () => {
  // slide-video-hv sınıfına sahip tüm öğeleri seç
  const videoContainers = document.querySelectorAll('.slide-video-hv');
  
  videoContainers.forEach(container => {
    // Her container içindeki video elementini bul
    const video = container.querySelector('video');
    
    if (video) {
      // Başlangıçta videoyu durdur
      video.pause();
      video.classList.remove('video-hover-effect');
      // Mouse üzerine geldiğinde videoyu oynat
      container.addEventListener('mouseenter', () => {
        video.play();
        video.classList.add('video-hover-effect');
      });
      
      // Mouse üzerinden gittiğinde videoyu durdur
      container.addEventListener('mouseleave', () => {
        video.pause();
        video.classList.remove('video-hover-effect');
      });
    }
  });
};

/**
 * Sayfa yüklendiğinde çalışacak tüm animasyonları başlatır
 */
export const initPageAnimations = () => {
  // Başlık animasyonunu başlat
  const cleanup = initTitleAnimation();
  
  // Açıklama ve video oynatma butonu animasyonlarını başlat
  initDescAnimation();
  
  // Header animasyonlarını başlat
  initHeaderAnimation();
  
  // Video hover efektlerini başlat
  initVideoHoverEffects();
  
  // Diğer sayfa animasyonları buraya eklenebilir
  
  // Temizleme fonksiyonunu döndür
  return cleanup;
}; 